<template>
  <div>
    <BaseLoadingBar is-small v-if="pending" />
    <div class="content__choices" v-else>
      <selection-tree :root="root" @onchange="onchange" ref="selectionTree"></selection-tree>
    </div>
  </div>
</template>

<script>
import BaseLoadingBar from '@/components/base/BaseLoadingBar';
import SelectionTree from '@/components/selection-tree/SelectionTree';
import { TreeParser } from '@/components/selection-tree/tree-parser';

import { mapGetters } from 'vuex';

export default {
  name: 'KeywordTree',
  components: {
    BaseLoadingBar,
    SelectionTree,
  },
  data() {
    return {
      root: {},
    };
  },
  computed: {
    ...mapGetters('keywords', ['languages', 'pending']),
    ...mapGetters('searchFilters', ['keywordIds']),
  },
  methods: {
    buildRoot() {
      const keywordTree = this.mapToKeywordTree(this.languages, this.keywordIds);
      const treeParser = new TreeParser();
      return treeParser.parse(keywordTree);
    },
    onchange(ids) {
      this.$emit('onchange', ids);
    },
    mapToKeywordTree(languages, keywordIds) {
      if (languages.length === 0) {
        return { children: [] };
      }

      return {
        children: languages.map(({ language, categories }) => ({
          key: language,
          title: this.$t(`languages.${language}`),
          children: categories.map(({ language, name, id, count, keywords }) => ({
            key: id,
            title: name,
            subtitle: this.$tc('dialog.keywords.keywords.count', count, { count }),
            language: language,
            children: keywords.map(({ id, value }) => ({
              key: id,
              value: id,
              title: value,
              checked: keywordIds.includes(id),
              children: [],
            })),
          })),
        })),
      };
    },
    clearSelection() {
      const keywordTree = this.mapToKeywordTree(this.languages, []);
      const treeParser = new TreeParser();
      this.root = treeParser.parse(keywordTree);
      this.$refs.selectionTree.clearSelection();
    },
  },
  created() {
    this.root = this.buildRoot();
  },
};
</script>

<style lang="scss"></style>
